import { combineReducers } from 'redux';

import { ICalendarSource } from '../../data/entities/calendar-source';
import { Actions, ActionTypes } from './actions';

export const byPropertyId = (state = {} as { [key: string]: ICalendarSource[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.CALENDAR_SOURCE_ICALS_GET_BY_PROP_ID_RECEIVE:
		case ActionTypes.CALENDAR_SOURCE_GET_BY_PROP_ID_RECEIVE:
			return { ...state, [action.payload.propertyId]: action.payload.calendarSources };
		case ActionTypes.CALENDAR_SOURCE_CREATE_RECEIVE:
			return { ...state, [action.payload.propertyId]: action.payload };
		default:
			return state;
	}
};

export const byCalendarSourceId = (state = {} as { [key: string]: ICalendarSource }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.CALENDAR_SOURCE_CREATE_RECEIVE:
			return { ...state, [action.payload.propertyId]: action.payload };
		default:
			return state;
	}
};

export interface ICalendarSourceState {
	byPropertyId: ReturnType<typeof byPropertyId>;
	byCalendarSourceId: ReturnType<typeof byCalendarSourceId>;
}

export default combineReducers<ICalendarSourceState>({
	byPropertyId,
	byCalendarSourceId
});
